import styled from "styled-components";
import { Button } from "rebass";

export const ControlButton = styled(Button)`
  text-transform: uppercase;
`;

ControlButton.defaultProps = {
  width: "120px",
  py: "15px",
  borderRadius: "5px",
  fontSize: "16px",
  fontWeight: "bold",
};
